export default __webpack_public_path__ + "static/media/brand_oca.002f59a9.svg";